import { render } from "./FoodSearch.vue?vue&type=template&id=5da15da0&scoped=true"
import script from "./FoodSearch.vue?vue&type=script&lang=js"
export * from "./FoodSearch.vue?vue&type=script&lang=js"

import "./FoodSearch.vue?vue&type=style&index=0&id=5da15da0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da15da0"]])

export default __exports__